import React from "react";

import Comment from "./Comment";
import classes from "./ActualComment.module.css";

export default class ActualComment extends React.Component {
  state = { show: false };
  render() {
    const replies = this.props.replies.map(reply => (
      <Comment
        name={reply.snippet.authorDisplayName}
        imgSrc={reply.snippet.authorProfileImageUrl}
        content={reply.snippet.textOriginal}
        likes={reply.snippet.likeCount}
        key={reply.id}
        date={reply.snippet.publishedAt}
        isReply={true}
      />
    ));
    let toggleBtn = null;
    if (replies.length > 0)
      toggleBtn = (
        <button
          className={classes.ToggleReplies}
          onClick={() => this.setState(pS => ({ show: !pS.show }))}
        >
          {this.state.show ? `Hide replies` : `View ${replies.length} replies`}
          {this.state.show ? (
            <i className="fas fa-chevron-up" />
          ) : (
            <i className="fas fa-chevron-down" />
          )}
        </button>
      );

    return (
      <div className={classes.ActualComment}>
        <Comment
          name={this.props.name}
          imgSrc={this.props.imgSrc}
          content={this.props.content}
          likes={this.props.likes}
          date={this.props.date}
        />
        {toggleBtn}
        <div
          style={{ display: this.state.show ? "block" : "none" }}
          className={classes.Replies}
        >
          {replies}
        </div>
      </div>
    );
  }
}
